import { render, staticRenderFns } from "./languageSettings.vue?vue&type=template&id=69e14be9&scoped=true"
import script from "./languageSettings.vue?vue&type=script&lang=js"
export * from "./languageSettings.vue?vue&type=script&lang=js"
import style0 from "./languageSettings.vue?vue&type=style&index=0&id=69e14be9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e14be9",
  null
  
)

export default component.exports